import axios from 'axios';
import Pagination from '@/domain/pagination.entity';
import Response from '@/domain/response.entity';
import ErrorMonitor from '../entity/error-monitor.entity';

export default class ErrorMonitorService {
  public static getAll(businessUnitId: string, filter: any, pagination: Pagination) {
    const params = {
      ...filter,
      page: pagination.page - 1,
      size: pagination.itemsPerPage,
      sortBy: pagination.arrangeSortBy,
    }
    return axios.get(`/api/v1/business-units/${businessUnitId}/calculation-parameter-integration-errors`, { params: { ...params } })
      .then((response: any) => Response.of(response.data))
  }

  public static getById(id: string): Promise<ErrorMonitor> {
    return axios.get(`/api/v1/calculation-parameter-integration-errors/${id}`)
      .then((response: any) => ErrorMonitor.of(response.data))
  }
}
